// extracted by mini-css-extract-plugin
export default {"container":"QualifyingCriteria_container__53397"};